function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { literalTypeValuesAndTypeValue } from "../../primitives";
import { idValidator } from "../misc/id-validator";
export const stateIdValidator = idValidator("state");
export const stateValidator = T.model("state", T.object({
    typeName: T.literal("state"),
    id: stateIdValidator,
    derivation: T.nullable(T.object({
        message: T.string,
        derivation: T.string
    })),
    locked: T.boolean,
    nonRemovable: T.boolean.optional(),
    // Origin?
    // path: T.string,
    defaultValue: literalTypeValuesAndTypeValue
}));
export const SWStateRecordType = createRecordType("state", {
    migrations: defineMigrations({}),
    validator: stateValidator,
    scope: "document"
}).withDefaultProperties(()=>({
        locked: false,
        derivation: null
    }));
export const castStateId = (id)=>{
    return {
        toStateValueId: ()=>{
            let parts = id.split(":");
            parts[0] = "state_value";
            return parts.join(":");
        }
    };
};
/** @public */ export function createStateId(id) {
    return `state:${id !== null && id !== void 0 ? id : nanoid()}`;
}
export function createState(state) {
    return _object_spread_props(_object_spread({}, state), {
        id: createStateId(state.id)
    });
}
export function isState(record) {
    if (!record) return false;
    return record.typeName === "state";
}
/** @public */ export function isStateId(id) {
    return SWStateRecordType.isId(id);
}
